import { LocalizableBodyInterface } from '@sport-activities/sdk';

export function getValueByLocale<T>(
  locatableBodies: LocalizableBodyInterface<T>[],
  locale: string,
  fallbackLocale?: string
): T | null {
  if (!locatableBodies || !(locatableBodies instanceof Array)) {
    return null;
  }

  const value =
    locatableBodies.find((locatableBody) => locatableBody.locale === locale)
      ?.value || null;

  if (value === undefined && fallbackLocale) {
    return (
      locatableBodies.find(
        (locatableBody) => locatableBody.locale === fallbackLocale
      )?.value || null
    );
  }

  return value;
}
